import { useEffect, useMemo } from 'react';
import type { Theme } from 'shared/src/types';

const themeRefCounts = new Map<string, number>();

export default function useTheme(theme: Theme) {
  const themeClassName = useMemo(() => `theme-${theme}`, [theme]);

  useEffect(() => {
    const body = document.body;
    themeRefCounts.set(themeClassName, (themeRefCounts.get(themeClassName) ?? 0) + 1);
    body.classList.add(themeClassName);

    return () => {
      const nextCount = (themeRefCounts.get(themeClassName) ?? 1) - 1;
      if (nextCount <= 0) {
        themeRefCounts.delete(themeClassName);
        body.classList.remove(themeClassName);
      } else {
        themeRefCounts.set(themeClassName, nextCount);
      }
    };
  }, [themeClassName]);
}
